export default __webpack_public_path__ + "static/grayRadial-38c720a9130575f28bb6ab51158c451c.png";